import React from "react";
import { transformToHtml } from "../../../utils/CommonUtils";

function getSearchTypeLabel(type, searchOptions) {
  if (!type || !searchOptions?.length) return type;
  const option = searchOptions.find((opt) => opt.type === type);
  return option?.text || type;
}

export default function SearchTypeDropdown({
  options = [],
  selectedOption,
  isOpen,
  onToggle,
  onSelect,
  readOnly = false,
}) {
  if (!options?.length) return null;

  return (
    <div className="fs-header__type">
      <div className="fs-header__type-label fontSize12">Search Type</div>
      {readOnly ? (
        <div className="fs-header__type-btn" aria-label="Search type">
          <span className="fs-header__type-value fontSize14">
            {transformToHtml(getSearchTypeLabel(selectedOption, options))}
          </span>
        </div>
      ) : (
        <button
          className="fs-header__type-btn"
          type="button"
          aria-haspopup="listbox"
          aria-expanded={isOpen}
          onClick={onToggle}
          aria-label="Select search type"
        >
          <span className="fs-header__type-value fontSize14">
            {transformToHtml(getSearchTypeLabel(selectedOption, options))}
          </span>
          <span className="downArrow" />
        </button>
      )}
      {!readOnly && isOpen && (
        <>
          <div className="fs-overlayBg" onClick={onToggle} aria-hidden="true" />
          <ul
            className="fs-header__dropdown"
            role="listbox"
            aria-label="Search type options"
          >
            {options.map((option) => (
              <li
                key={option?.type || Math.random()}
                className={`fontSize12 fs-header__dropdown-item${
                  selectedOption === option?.type ? " selected" : ""
                }`}
                role="option"
                aria-selected={selectedOption === option?.type}
                onClick={() => option?.type && onSelect(option.type)}
              >
                {transformToHtml(option?.text || "")}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
